import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-lightShow flex items-center justify-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "p-4 text-left" }, "Sorry... 予期せぬエラーが発生しました。", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dv = _resolveComponent("dv")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_dv, null, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("button", {
          class: "text-center block w-full items-center rounded-md border border-transparent bg-gray-showButton px-8 py-2 text-base font-medium text-white shadow-sm",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goNextPage && _ctx.goNextPage(...args)))
        }, _toDisplayString(_ctx.buttonText), 1)
      ]),
      _: 1
    })
  ]))
}